import React, { ReactNode } from "react";

export const ReportContainerRight = ({
  children,
}: {
  children: ReactNode;
}): JSX.Element => (
  <div style={{ width: "100%", height: "80vh" }}>{children}</div>
);
